import React, {useEffect, useRef, useState} from 'react';
import {AuthLayout} from "../../../core/layout/AuthLayout";
import BtnPrimary from "../../../shared/ui/button/primary/BtnPrimary";
import {FormElements} from "../../../shared/ui/form/FormElements";
import {StructureFormModel} from "../../../shared/ui/form/models/FormModule";
import {formControlTypes} from "../../../shared/ui/form/models/formControlTypes";
import {useForm} from "../../../shared/utils/forms/useForm";
import {useSelector} from "react-redux";
import {selectSelectedPharmacy} from "../../../core/reducer/pharmacySlice";
import http from "../../../shared/utils/http";
import {exportPdf} from "../../../shared/utils/exportPdf";
import {typeHoursInitArray} from "../../../common/typeHours";


export function
Stats() {
    const pharmacy = useSelector(selectSelectedPharmacy)
    const isTimeBank = !!pharmacy?.timeBank;
    const [data, setData] = useState<any>(undefined);

    const printHandler = () => {
        setPrintView(true)
    }
    const structureDataTypeHour: StructureFormModel[] = [
        {
            type: formControlTypes.input,
            name: "startDate",
            dataElement: {
                placeholder: "Seleziona data inizio",
                type: 'date',
            },
            col: {xs: "12", sm: "4"},
        },
        {
            type: formControlTypes.input,
            name: "endDate",
            dataElement: {
                placeholder: "Seleziona data fine",
                type: 'date',
            },
            col: {xs: "12", sm: "4"},
        }
    ]

    const submitHandler = (event: any, data: any) => {
        const start = new Date(data.startDate)
        const end = new Date(data.endDate)
        http.get(`pharmacies/${pharmacy?.idDocument}/situation/hours/${start.getFullYear()}/${start.getMonth()}/${start.getDate()}/${end.getFullYear()}/${end.getMonth()}/${end.getDate()}`).then(res => {
            setData(res.infos)
        })
    }
    const {
        dataFormatted,
        dataForm,
        errors,
        isSubmit,
        changeValue,
        submitAction
    } = useForm(submitHandler)

    const [printView, setPrintView] = useState<boolean>(false)

    const pdfRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (printView) {
            exportPdf(`${pharmacy?.name}_statistiche`, pdfRef, () => {
                window.close()
                setPrintView(false)
            })
        }
    }, [printView]);

    return (
        <AuthLayout>
            <div className="row" ref={pdfRef}>
                <div className="col pt-3">
                    <div className={'d-flex justify-content-between align-items-center'}>
                        <div className={'d-flex align-items-center gap-3 w-100'}>
                            <h3 className={'text-nowrap mb-4'}>Statistiche</h3>
                        </div>
                        <div className={'d-flex gap-2 w-100'}>
                            <div className={'ms-auto w-100'}>
                                <FormElements structure={structureDataTypeHour} changeValue={changeValue}
                                              dataForm={dataForm}
                                              style={{justifyContent: 'end'}}
                                              errors={errors} isSubmit={isSubmit}/>
                            </div>
                            {!printView &&
                                <div className={'d-flex gap-2'}><BtnPrimary title="Filtra"
                                                                            icon={'./assets/icons/filter.svg'}
                                                                            disabled={false}
                                                                            variant={'primary'}
                                                                            onClick={() => submitAction()}></BtnPrimary>
                                    <BtnPrimary title="Stampa" icon={'./assets/icons/print.svg'} disabled={false}
                                                variant={'outline-primary'} className={'text-cyan-500 border-cyan-500'}
                                                onClick={() => printHandler()}></BtnPrimary>
                                </div>}
                        </div>
                    </div>

                    {data ? <div className="col list-container">
                        {dataFormatted.startDate && dataFormatted.endDate && <h5>
                            {dataFormatted.startDate} - {dataFormatted.endDate}
                        </h5>}
                        <table className={'table-print'}>
                            <thead>
                            <tr>
                                <th>Nominativo</th>
                                <th>Ore totali</th>
                                <th>Ore standard</th>
                                <th>Ore festive</th>
                                <th>Ore domenicali</th>
                            </tr>
                            </thead>
                            <tbody>
                            {data.map((dt: any) => {
                                return <tr>
                                    <td>{dt.employee?.name} {dt.employee?.surname}</td>
                                    <td>
                                        {(((dt?.info?.work + dt?.info?.work_festive + dt?.info?.work_sunday) || 0) / 60).toFixed(2)}
                                    </td>
                                    <td>{((dt?.info?.work || 0) / 60).toFixed(2)}</td>
                                    <td>{((dt?.info?.work_festive || 0) / 60).toFixed(2)}</td>
                                    <td>{((dt?.info?.work_sunday || 0) / 60).toFixed(2)}</td>
                                </tr>
                            })}
                            </tbody>
                        </table>
                    </div> : <div>Filtra per data inizio e fine</div>}
                </div>
            </div>
        </AuthLayout>
    );
}


